import {
  BreakpointQueryName, getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';
import { css } from 'styled-components';

const desktopImageWidth = '13.5rem';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.darkest};
  background-color: ${theme.palettes.neutrals.lightest};
  position: relative;
  cursor: pointer;
  max-height: 100%;
`;

export const imageWrapper: ThemedFunctor = ({
  theme,
}) => css`
  background-color: ${theme.palettes.neutrals.lighter};

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: ${desktopImageWidth};
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const imagePlaceholder = css`
  padding-top: 66%;
  width: 100%;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
    margin-top: ${theme.spaceUnits.mobile.MEDIUM};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding-left: ${getSpacing.sum(desktopImageWidth, '1.25rem')};
    margin-top: 0;
    min-height: 8.9rem;
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}

  a {
    color: ${theme.palettes.neutrals.darkest};
    text-decoration: none;
  }
`;

export const details: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  margin-top: .3rem;

  span {
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.SM)} {
    span {
      margin-right: 0.5rem;
      display: inline;

      &:not(:last-child)::after {
        content: '-';
        margin-left: 0.5rem;
      }
    }
  }
`;

export const abstract: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.SMALL)}
  line-height: 1.4 !important;
`;
